import React from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaTrash } from "react-icons/fa";
import config from '../../config';

const Roles = () => {
    const companyId = useSelector((state) => state.user.companyId);

    const [roleList, setRoleList] = useState([])
    const [err, setErr] = useState("")
    const [inputs, setInputs] = useState({
        clientName: "",
        clientCode: "",
        categoryId: 0,
        basketId: 0,
        fromDate: null,
        toDate: null,
    })

    const email = useSelector((state) => state.user.email);
    const navigate = useNavigate();
    useEffect(() => {
        if (email === null || email === "") {
            navigate("/")
        }
    })

    useEffect(() => {
        const today = new Date();
        const dateString = today.toISOString().substring(0, 10);
        inputs.fromDate = dateString;
        handleSearch(null);
        //getCashLedger();
    }, [])


    const handleClearSearch = async (e) => {
        let clientName = document.getElementById("client-Name");
        let clientCode = document.getElementById("client-Code");
        let fromDate = document.getElementById("fromDate");
        let toDate = document.getElementById("toDate");
        let basket = document.getElementById("basketId");
        let category = document.getElementById("categoryId");
        clientName.value = ""
        clientCode.value = ""
        fromDate.value = ""
        toDate.value = ""
        basket.value = ""
        category.value = ""
        setInputs({
            clientName: "",
            clientCode: "",
            categoryId: 0,
            basketId: 0,
            fromDate: null,
            toDate: null,
        });
        setRoleList([]);
    }

    const handleSearch = async (e) => {
        try {

            const res = await axios.get(config.BL_API_URL + "/role/v1/getRoles");

            if (res.data) {
                setRoleList(res.data);
            }
            else {
                setErr("backend error")
            }

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    const deleteRole = async (id) => {
        console.log("clicked" + id)
        try {
            let id1 = Number(id);
            console.log(id1)
            const requestBody = { id: id1 };
            const res = await axios.post(config.BL_API_URL + "/role/v1/deleteRole", requestBody);

            if (res.status === 200)
                handleSearch();
            else
                setErr("backend error")

        } catch (err) {
            //console.log("first")
            if (err.response)
                setErr(err.response.data);
            else
                setErr("Server error...");
        }
    }

    function formatNumber(value) {
        return new Intl.NumberFormat('en-IN').format(value);
    }

    function formatDate(value) {
        if (value == null || value == undefined || value == "") {
            return;
        }
        return new Intl.DateTimeFormat('en-IN').format(value);
    }
    const handleChange = (e) => {
        setInputs(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }


    return (
        <div className="my-12 md:px-14 p-4 max-w-screen-md mx-auto ">
            <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">

                    <div className="border rounded-lg divide-y divide-gray-200 py-5">
                        <div className='col-span-2'>
                            <div className=" col-span-1">
                                <div className=' flex  gap-x-1 px-1 py-1 overflow-ellipsis'>
                                    <div className="grid  gap-2 justify-right border-0 border-red-500">

                                        <div className=" gap-0 justify-right text-xs " >
                                            <Link to="/AddRole" type="button" className="py-2 px-2 inline-flex right-0 gap-x-2 text-sm text-nowrap font-semibold rounded-lg border border-transparent bg-btnSecondary text-white hover:bg-btnPrimary disabled:opacity-50 disabled:pointer-events-none " data-hs-overlay="#hs-basic-modal">Add Role</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="overflow-hidden col-span-1">
                            <div className="max-h-96 overflow-y-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50 sticky top-0 z-10">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Role Name</th>
                                            <th scope="col" className="px-6 py-3 text-start text-xs font-medium text-gray-500 bg-gray-200 uppercase">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {roleList &&
                                            roleList.map((role, index) => (
                                                <tr key={role.id} className="odd:bg-white even:bg-gray-100 hover:bg-gray-300 cursor-pointer">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">{role.name}</td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm  text-gray-800 ">
                                                        <span onClick={() => { deleteRole(role.id); }} className="text-red-500 hover:text-red-700 cursor-pointer">
                                                            <FaTrash />
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        {(roleList === null || roleList.length <= 0) &&
                                            <tr><td colSpan={2} className='text-center text-red-500 '>No records to display!</td></tr>
                                        }
                                        <tr><td colSpan={2} className='text-center text-red-500'>{err}</td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}

export default Roles;